import styled, { css } from 'styled-components';
import { Loader as LoaderComponent } from 'src/components';

export const PageContent = styled.div(
  ({ theme }) => css`
    display: grid;
    grid-template-areas:
      'benefits prices'
      'review prices'
      'faq prices';
    grid-template-columns: 2fr 1fr;
    row-gap: ${theme.sz.s12};
    column-gap: ${theme.sz.s5};
    max-width: ${theme.sz.xxl};
    margin: auto;
    padding: ${theme.sz.s6};

    @media (max-width: ${theme.sz.lg}) {
      grid-template-columns: 1fr;
      grid-template-rows: auto;
      grid-template-areas:
        'benefits'
        'prices'
        'review'
        'faq';
      row-gap: ${theme.sz.s8};
    }
  `,
);

export const Loader = styled(LoaderComponent)(
  ({ theme }) => css`
    max-height: ${theme.sz.s40};
    margin: auto;
    display: block;
  `,
);

export const StickyFooter = styled.div(
  ({ theme }) => css`
    display: none;

    @media (max-width: ${theme.sz.lg}) {
      display: block;
      position: sticky;
      z-index: ${theme.zi.z1};
      bottom: ${theme.sz.s0};
      background-color: ${theme.co.neutral99};
      padding: ${theme.sz.s4};
    }
  `,
);
